import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Content } from './Content';
import * as S from './styles';

export function InfoTooltip() {
	function renderTitle() {
		return <Content />;
	}

	return (
		<S.CustomTooltip showArrow={false} title={renderTitle} getPopupContainer={(triggerNode) => triggerNode}>
			<InfoCircleOutlined />
		</S.CustomTooltip>
	);
}
